import React from "react";
import Reveal from "./Reveal";
import { Phone, Mail, MapPin, ArrowUpRight, User } from "lucide-react";

const contacts = [
  {
    name: "Hemal Busa",
    phone: "+91 98196 08652",
    phoneHref: "tel:+919819608652",
    email: "hemalbusa@rediffmail.com",
    emailHref: "mailto:hemalbusa@rediffmail.com",
  },
  {
    name: "Devang Mehta",
    phone: "+91 99204 40732",
    phoneHref: "tel:+919920440732",
    email: "dmehta413@gmail.com",
    emailHref: "mailto:dmehta413@gmail.com",
  },
];

export const Contact = () => {
  return (
    <section id="contact" data-testid="contact-section" className="relative py-28 md:py-40 bg-bone-100">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-10">
          <div className="col-span-12 lg:col-span-6">
            <Reveal>
              <span className="font-mono text-[11px] uppercase tracking-[0.32em] text-gold-deep">
                / 07 — Begin a Conversation
              </span>
            </Reveal>
            <Reveal delay={120}>
              <h2 className="mt-6 font-display text-4xl md:text-5xl lg:text-6xl text-slate-900 leading-[1.05] tracking-tight">
                Briefs are best <span className="italic text-gold-deep">discussed</span>, not filled in.
              </h2>
            </Reveal>
            <Reveal delay={220}>
              <p className="mt-8 text-base text-slate-700 leading-relaxed max-w-md">
                Whether you are a builder, architect, developer or industrial client — reach
                out to either of the partners below, and we will route your enquiry to the
                right team without delay.
              </p>
            </Reveal>

            {/* Partner cards */}
            <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-px bg-slate-900/8 border border-slate-900/8">
              {contacts.map((c, i) => (
                <Reveal
                  key={c.name}
                  delay={i * 120}
                  className="bg-white p-7 hover:bg-bone-50 transition-colors duration-300"
                  data-testid={`contact-partner-${i}`}
                >
                  <div className="flex items-center gap-3">
                    <User size={16} strokeWidth={1.25} className="text-gold-deep" />
                    <span className="font-mono text-[10px] uppercase tracking-[0.28em] text-slate-500">
                      Partner · Direct
                    </span>
                  </div>
                  <div className="mt-4 font-display text-3xl text-slate-900 leading-tight">
                    {c.name}
                  </div>

                  <a
                    href={c.phoneHref}
                    data-testid={`contact-phone-${i}`}
                    className="group mt-6 flex items-center gap-3 text-slate-900 hover:text-gold-deep transition-colors"
                  >
                    <Phone size={14} strokeWidth={1.5} className="text-gold-deep/80" />
                    <span className="text-sm tracking-wide">{c.phone}</span>
                    <ArrowUpRight size={12} className="opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                  </a>
                  <a
                    href={c.emailHref}
                    data-testid={`contact-email-${i}`}
                    className="group mt-3 flex items-center gap-3 text-slate-900 hover:text-gold-deep transition-colors break-all"
                  >
                    <Mail size={14} strokeWidth={1.5} className="text-gold-deep/80" />
                    <span className="text-sm tracking-wide">{c.email}</span>
                    <ArrowUpRight size={12} className="opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all flex-shrink-0" />
                  </a>
                </Reveal>
              ))}
            </div>

            {/* Office */}
            <Reveal
              delay={300}
              data-testid="contact-address"
              className="mt-px flex items-start gap-5 bg-white px-7 py-6 border border-slate-900/8"
            >
              <MapPin size={20} strokeWidth={1.25} className="text-gold-deep flex-shrink-0 mt-1" />
              <div>
                <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-slate-500">Office</div>
                <div className="mt-2 font-display text-xl md:text-2xl text-slate-900 leading-snug">
                  1805, Chandak Unicorn, Dattaji Salve Marg,<br />
                  Off Veera Desai Road, Opp. Pizza Express,<br />
                  Andheri (W), Mumbai — 400053
                </div>
              </div>
            </Reveal>
          </div>

          <div className="col-span-12 lg:col-span-6">
            <Reveal delay={150}>
              <div className="blueprint-border overflow-hidden bg-white">
                <iframe
                  title="Office location"
                  data-testid="contact-map"
                  src="https://www.google.com/maps?q=Chandak+Unicorn+Dattaji+Salve+Marg+Veera+Desai+Road+Andheri+West+Mumbai+400053&output=embed"
                  width="100%"
                  height="640"
                  style={{ border: 0, filter: "grayscale(0.35) contrast(1.05) saturate(0.9)" }}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </Reveal>

            <Reveal delay={250} className="mt-6 flex items-center justify-between text-[11px] font-mono uppercase tracking-[0.28em] text-slate-500">
              <span>Mumbai · Pune · MIDC Chakan</span>
              <span>Mon — Sat · 10:00 — 19:00 IST</span>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
